
import { mapGetters } from 'vuex'

import BuyingGuideCard from '@article/components/Card'

export default {
  components: {
    BuyingGuideCard,
  },

  computed: {
    ...mapGetters({
      buyingGuide: 'landing/buyingGuide',
    }),
  },
}
